import { Card, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

const messages = defineMessages({
  title: {
    id: 'shareInstructions.title',
    defaultMessage: 'How to share a record:',
  },
  custom: {
    id: 'shareInstructions.custom',
    defaultMessage:
      'By sharing specific records, you can choose exactly who has access to what and for how long, giving you total control over your private records. This ensures it remains available to those who need it, and safe from those who don’t.',
  },
  followSteps: {
    id: 'shareInstructions.followSteps',
    defaultMessage:
      'Sharing records is safe, secure, and simple. Follow these steps:',
  },
  share: {
    id: 'shareButton.share',
    defaultMessage: 'Share',
  },
});

export default function ShareInstructions() {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6">{formatMessage(messages.title)}</Typography>

          <Typography variant="subtitle1">
            {formatMessage(messages.custom)}
          </Typography>

          <Typography variant="subtitle1">
            {formatMessage(messages.followSteps)}
          </Typography>

          <ol>
            {[
              'one',
              'two',
              'three',
              'four',
              'five',
              'six',
              'seven',
              'eight',
            ].map((step, index) => (
              <li key={`share-instructions-step-${index + 1}`}>
                {step === 'two' ? (
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    display="block"
                  >
                    <Typography component="span" variant="body1">
                      {formatMessage({
                        id: 'shareInstructions.steps.two.partOne',
                      })}
                    </Typography>
                    <span>
                      <Icon
                        color="primary.main"
                        name="share-nodes"
                        type="fas"
                        style={{ verticalAlign: 'middle' }}
                      />
                      <Typography
                        component="span"
                        color="primary.main"
                        sx={{ pl: 1 }}
                        variant="overline"
                        lineHeight="100%"
                      >
                        {formatMessage(messages.share)}
                      </Typography>
                    </span>
                    <Typography component="span" variant="body1">
                      {formatMessage({
                        id: 'shareInstructions.steps.two.partTwo',
                      })}
                    </Typography>
                  </Stack>
                ) : (
                  <Typography variant="body1">
                    {formatMessage({ id: `shareInstructions.steps.${step}` })}
                  </Typography>
                )}
              </li>
            ))}
          </ol>
        </Stack>
      </CardContent>
    </Card>
  );
}
